import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const CUSTOMER_ALLOWED = ['/calculator', '/pro-search'];

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  // Limited customer accounts: only the reference calculator and pro search.
  // No 2FA, no staff pages — anything else bounces to the calculator.
  if (user.role === 'customer') {
    if (!CUSTOMER_ALLOWED.includes(location.pathname)) {
      return <Navigate to="/calculator" replace />;
    }
    return children;
  }

  // Force 2FA setup before anything else (except the setup page itself)
  if (user.totp_enabled === false && location.pathname !== '/setup-2fa') {
    return <Navigate to="/setup-2fa" replace />;
  }

  const roleLevel = { employee: 1, boss: 2, admin: 3 };
  if (requiredRole && roleLevel[user.role] < roleLevel[requiredRole]) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
